import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

// Function to check if personalDetails has the required fields from the label
const hasPersonalDetails = (label, personalDetails)=>{
    // If there is not personal data, return false
    if (!personalDetails) {
        return false;
    }
    // Get label parameters
    const matches = label.match(/\{([^}]+)\}/g);
    // If there are no placeholders, we don't need to check anything
    if (!matches) {
        return true;
    }
    //check if personal details has the property
    const parameters = matches.map((match)=>{
        const property = match.replace(/[{}]/g, '');
        if (personalDetails[property]) {
            return true;
        }
        return false;
    });
    //all parameters must be exist in personal details
    return parameters.every((parameter)=>parameter
    );
};
const PersonalizedGreeting = ({ personalDetails  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const augmentedPersonalDetails = swcHelpers.objectSpread({}, personalDetails, (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName) ? {
        firstLetter: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName.substring(0, 1)
    } : {});
    const message = hasPersonalDetails(getLabel('account.menu.greeting.withPersonalDetails'), augmentedPersonalDetails) ? getFormattedLabel('account.menu.greeting.withPersonalDetails', {
        labelData: augmentedPersonalDetails
    }) : getLabel('account.menu.greeting.withoutPersonalDetails');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "user-checkmark"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "myaccount-menu-button__label",
        "data-t": "personalized-greeting"
    }, message));
};

export { PersonalizedGreeting };
//# sourceMappingURL=PersonalizedGreeting.js.map
